// @ts-nocheck
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export const addArtSelectionImagesToProduct = (product: CartLineModel | ProductModel, artSelectionId?: string) => {
    const artSelectionImages = getArtSelectionImages(product, artSelectionId);
    if (artSelectionImages) {
        product.smallImagePath = artSelectionImages.smallImagePath;
        if ("mediumImagePath" in product && "largeImagePath" in product) {
            product.mediumImagePath = artSelectionImages.mediumImagePath;
            product.largeImagePath = artSelectionImages.largeImagePath;
        }
    }
};

export const getArtSelectionFirstImage = (product: CartLineModel | ProductModel, artSelectionId?: string) => {
    return getArtSelectionImages(product, artSelectionId)?.[0];
};

export const getArtSelectionImages = (product: CartLineModel | ProductModel, artSelectionId?: string) => {
    const artSelection = getArtSelection(product, artSelectionId);

    if (artSelection && artSelection.images.length) {
        return artSelection.images;
    }
};

export const getArtSelectionDocuments = (product: CartLineModel | ProductModel, artSelectionId?: string) => {
    const artSelection = getArtSelection(product, artSelectionId);

    if (artSelection && artSelection.documents.length) {
        return artSelection.documents;
    }
};

export const getArtSelection = (product: CartLineModel | ProductModel, artSelectionId?: string) => {
    const artSelections = getAllArtSelection(product);
    if (artSelections && artSelections.length > 0) {
        let artSelection = artSelections.find((a: any) => !a.isNew) || artSelections.find((a: any) => a.isNew);
        if (artSelectionId) {
            const artSelectionTmp = artSelections.find((a: any) => a.id === artSelectionId);
            if (artSelectionTmp) {
                artSelection = artSelectionTmp;
            }
        }

        return artSelection;
    }
};

export const getAllArtSelection = (product: CartLineModel | ProductModel) => {
    if (product.properties["artSelections"]) {
        return JSON.parse(product.properties["artSelections"]);
    }
    return undefined;
};
